module.exports = __webpack_public_path__ + "img/icon_sb_unselect_star_trustpilot_t.d78b7da.svg";